var React = require('react');

function Gate (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Gate"),React.createElement("g",{"id":"g1457","key":2},[React.createElement("polyline",{"id":"rect7036","className":"cls-1","points":"23.4 35.12 23.4 20.68 45.06 20.68 66.72 20.68 88.38 20.68 110.04 20.68 110.04 42.34 110.04 64 110.04 85.66 110.04 107.32 88.38 107.32 66.72 107.32 45.06 107.32 23.4 107.32 23.4 92.88","key":0}),React.createElement("path",{"id":"path7034-7","className":"cls-1","d":"M54.06,64,9,35.12V92.88Z","key":1})])]);
}

Gate.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Gate;

Gate.default = Gate;
